import { useDispatch } from 'react-redux';
import { clearProductsCompare } from '@client/product/redux/productsCompare/redux';
import { bindActionCreators } from '@reduxjs/toolkit';

export const useClearProductsCompareAction = (): typeof clearProductsCompare => {
  const dispatch = useDispatch();

  return bindActionCreators(clearProductsCompare, dispatch);
};
